import { HttpResponse } from "@angular/common/http";
import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ReportEvaluationDisciplineFiltersDTO } from "../../models/export-report.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

export class ExportDisciplineReportUseCase
  implements UseCase<ReportEvaluationDisciplineFiltersDTO, HttpResponse<Blob>>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(filters: ReportEvaluationDisciplineFiltersDTO): Observable<HttpResponse<Blob>> {
    return this.repo.exportDisciplineReport(filters);
  }
}

const exportDisciplineReportUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new ExportDisciplineReportUseCase(repo);

export const exportDisciplineReportUseCaseProvider: Provider = {
  provide: ExportDisciplineReportUseCase,
  useFactory: exportDisciplineReportUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
